export default "__VITE_ASSET__Bv$mlpyp__"